import { socialLinksRef } from "../config/firebase";

import { 
    FETCH_SOCIAL_INFO,
    FETCH_SOCIAL_INFO_SUCCESS,
    FETCH_SOCIAL_INFO_FAILED,
} from "./types";

export const fetchSocialInfo = () => dispatch => {
    dispatch({
      type: FETCH_SOCIAL_INFO,
      payload: null
    });
    socialLinksRef.on("value", snapshot => {
      if (snapshot.val()) {
        dispatch({
          type: FETCH_SOCIAL_INFO_SUCCESS,
          payload: snapshot.val()
        });
      } else {
        dispatch({
          type: FETCH_SOCIAL_INFO_FAILED,
          payload: "No infos available."
        });
      }
    });
  };
